import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

export const VideoLibrary = React.lazy(() => import("@kaltura/mediaspace-features-vod-avatars/VideoLibrary"));
export const VideoLibraryMenuItem = React.lazy(
    () => import("@kaltura/mediaspace-features-vod-avatars/VideoLibraryMenuItem")
);
export const render = getDsLayoutComponentRenderer(VideoLibrary);
